import { createFileRoute } from '@tanstack/react-router';

import {
  payoutProfileQueryOptions,
  settlementSummaryQueryOptions,
} from '@/features/settlements/api';
import { PayoutProfilePage } from '@/features/settlements/components/payout-profile-page';

export const Route = createFileRoute('/_app/settlements/payout-profile')({
  staticData: { title: '정산 정보', group: '정산' },
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.query({ ...payoutProfileQueryOptions(), staleTime: 'static' }),
      queryClient.query({ ...settlementSummaryQueryOptions(), staleTime: 'static' }),
    ]),
  head: () => ({ meta: [{ title: '정산 정보 · 팬즈드롭 파트너' }] }),
  component: PayoutProfilePage,
});
